// extracted by mini-css-extract-plugin
export default {"ContainerPreprojects":"Preprojects_ContainerPreprojects__XXSh+"};